export default "__VITE_ASSET__CFmh9r0S__"